var chunkMapping = {
	"0": [
		4911
	],
	"3": [
		4000,
		4542
	],
	"97": [
		5038
	],
	"125": [
		5066
	],
	"126": [
		5067
	],
	"127": [
		5068
	],
	"130": [
		5071
	],
	"133": [
		5074
	],
	"134": [
		5075
	],
	"135": [
		5076
	],
	"136": [
		5077
	],
	"137": [
		5078
	],
	"138": [
		5079
	],
	"139": [
		5080
	],
	"140": [
		5081
	],
	"141": [
		5082
	],
	"142": [
		5083
	],
	"143": [
		5084
	],
	"144": [
		5085
	],
	"145": [
		5086
	],
	"146": [
		5087
	],
	"147": [
		5088
	],
	"148": [
		5089
	],
	"149": [
		5090
	],
	"150": [
		5091
	],
	"151": [
		5092
	]
};
var idToExternalAndNameMapping = {
	"4000": [
		"default",
		"./nuorder-components",
		3675
	],
	"4542": [
		"default",
		"./helios-components",
		3675
	],
	"4911": [
		"default",
		"./Containers",
		3584
	],
	"5038": [
		"default",
		"./OrderlessInvoices",
		3584
	],
	"5066": [
		"default",
		"./CheckoutV3",
		3584
	],
	"5067": [
		"default",
		"./HostWrapper",
		3584
	],
	"5068": [
		"default",
		"./CheckoutConfirmation",
		3584
	],
	"5071": [
		"default",
		"./AsyncEventTracker",
		3584
	],
	"5074": [
		"default",
		"./ContactCreditCards",
		3584
	],
	"5075": [
		"default",
		"./AuditDialog",
		3584
	],
	"5076": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3584
	],
	"5077": [
		"default",
		"./InvoiceDialog",
		3584
	],
	"5078": [
		"default",
		"./PaymentDueModal",
		3584
	],
	"5079": [
		"default",
		"./PaymentModal",
		3584
	],
	"5080": [
		"default",
		"./MobilePaymentsWrapper",
		3584
	],
	"5081": [
		"default",
		"./Challenge",
		3584
	],
	"5082": [
		"default",
		"./ShippingPromotionsListContainer",
		3584
	],
	"5083": [
		"default",
		"./Teams",
		3860
	],
	"5084": [
		"default",
		"./LightspeedReports",
		3584
	],
	"5085": [
		"default",
		"./ActivateLightspeedPayments",
		3584
	],
	"5086": [
		"default",
		"./MarketingLandingPage",
		3584
	],
	"5087": [
		"default",
		"./PaymentHistory",
		3584
	],
	"5088": [
		"default",
		"./ManagePaymentProcessing",
		3584
	],
	"5089": [
		"default",
		"./PaymentPreferences",
		3584
	],
	"5090": [
		"default",
		"./PaymentConfigurations",
		3584
	],
	"5091": [
		"default",
		"./ManagePaymentMethods",
		3584
	],
	"5092": [
		"default",
		"./PayPage",
		3584
	]
};
var idToRemoteMap = {
	"4000": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3675
		}
	],
	"4542": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3675
		}
	],
	"4911": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5038": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5066": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5067": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5068": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5071": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5074": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5075": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5076": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5077": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5078": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5079": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5080": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5081": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5082": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5083": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3860
		}
	],
	"5084": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5085": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5086": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5087": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5088": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5089": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5090": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5091": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	],
	"5092": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3584
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}